import {Component, OnInit} from '@angular/core';
import {SepaImport} from '../../../../dto/sepa-import';
import {SepaImportError} from '../../../../dto/sepa-import-error';
import {SepaImportService} from '../../../services/sepa-import.service';
import {ActivatedRoute} from '@angular/router';
import {DatePipe} from '@angular/common';
import {DateFormats} from '../../../../providers/app-date-adapter';
import {Sepa} from '../../../../dto/sepa';
import {MatTableDataSource} from '@angular/material/table';
import {RoleService} from '../../../../services/role.service';

@Component( {
  selector: 'app-sepa-import-view',
  templateUrl: './sepa-import-view.component.html',
  styleUrls: [ './sepa-import-view.component.css' ]
} )
export class SepaImportViewComponent implements OnInit {

  import: SepaImport;
  importDataDataSource: MatTableDataSource<Sepa>;
  importErrorsDataSource: MatTableDataSource<SepaImportError>;

  importCols = [
    { header: 'ID', cell: ( row: SepaImport ) => `${ row.id }` },
    { header: 'Date', cell: ( row: SepaImport ) => `${ this.datePipe.transform( row.date, DateFormats.DisplayDateTime ) }` },
    { header: 'User', cell: ( row: SepaImport ) => `${ row.username }` },
    { header: 'Invalid rows', cell: ( row: SepaImport ) => `${ row.invalidRowCount }` },
    { header: 'Total rows', cell: ( row: SepaImport ) => `${ row.totalRowCount }` },
  ];

  importDataCols = [
    { columnDef: 'token', header: 'Token', cell: ( row: Sepa ) => `${ row.token }` },
    { columnDef: 'amount', header: 'Amount', cell: ( row: Sepa ) => `${ row.amount }` },
    { columnDef: 'date', header: 'Date', cell: ( row: Sepa ) => `${ this.datePipe.transform( row.date, DateFormats.DisplayDate ) }` },
  ];

  importErrorsCols = [
    { columnDef: 'rowNumber', header: 'Row number', cell: ( row: SepaImportError ) => `${ row.rowNumber }` },
    { columnDef: 'ParsedValue', header: 'Parsed value', cell: ( row: SepaImportError ) => `${ row.parsedValue }` },
    { columnDef: 'errorText', header: 'Error Text', cell: ( row: SepaImportError ) => `${ row.errorText }` },

  ];

  constructor(
    private importService: SepaImportService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private roleService: RoleService,
  ) { }

  ngOnInit() {
    const id = parseInt( this.route.snapshot.paramMap.get( 'id' ) );
    this.importService.get( id ).subscribe( result => {
      this.import = result;
      this.importDataDataSource = new MatTableDataSource( result.sepas );
      this.importErrorsDataSource = new MatTableDataSource( result.importErrors );
    } );
  }
  getRowClass = ( item: Sepa ): string => item.importErrorsText ? 'warning-row' : '';

  deleteEnabled() {
    return this.roleService.hasRoles( 'admin' );
  }

  multiselectEnabled() {
    return this.roleService.hasRoles( ['admin'] );
  }
}
